<ion-header>
    <ion-toolbar>
        <ion-title>{{'Policy' | translate}}</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="modalDissmissed()" fill="clear" color="dark">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    @if(leaguePolicy && isOwner){
      <div class="content-width">
        <h2>{{leaguePolicy.name}}</h2>
        <div class="ion-padding accordion-content" slot="content">
          <ion-item>
            {{'Time Format' | translate}} :
            <strong>{{leaguePolicy?.configuration?.timeouts?.timeFormat}}</strong>
          </ion-item>
          <ion-item>
            {{'Timeout Duration' | translate}} :
            <strong>
              {{leaguePolicy?.configuration?.timeouts?.timeoutDuration}}</strong
            >
          </ion-item>
          <ion-item>
            {{'Timeout Per Match' | translate}} :
            <strong>
              {{leaguePolicy?.configuration?.timeouts?.timeoutPerMatch}}</strong
            >
          </ion-item>
          <ion-item>
            {{'Timeout Per Set' | translate}} :
            <strong> {{leaguePolicy?.configuration?.timeouts?.timeoutPerSet}}</strong>
          </ion-item>
        </div>
      </div>
    } @else {
      <app-empty-page class="content-width" [text]="noPolicyText" iconName="people"></app-empty-page>
    }
</ion-content>
